<template>
  <v-container class="section mt-16 pt-8" id="about">
    <!-- The artwork -->
    <v-img
      contain
      height="347"
      src="/img/svg/team.svg"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    />

    <!-- The section heading -->
    <div
      class="font-weight-bold bluegray--text text-h4 text-center"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Meet the <span class="primary--text">Team</span>
    </div>

    <!-- The subtitle -->
    <div
      class="section__subtitle text-center mt-4"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      Veterans from the World of Marketing having established multiple brands across new age consumers brands in the internet age
    </div>

    <!-- A grid of team members -->
    <div
      class="d-flex justify-center mt-8"
      v-vue-aos.once="{ animationClass:'fadeIn slow animated' }"
    >
      <!-- The card -->
      <div class="box d-flex flex-column justify-center align-center white box-shadow-soft-hover mx-3">
        <!-- The image -->
        <v-img
          contain
          width="150"
          max-height="150"
          src="/img/home/team/kalyan.png"
        />

        <!-- The name -->
        <div class="font-weight-bold text-h5 mt-6">
          Kalyan Kumar
        </div>

        <!-- The designation -->
        <div>
          Chief Executive Officer
        </div>
      </div>

      <!-- The card -->
      <div class="box d-flex flex-column justify-center align-center white box-shadow-soft-hover mx-3">
        <!-- The image -->
        <v-img
          contain
          width="150"
          max-height="150"
          src="/img/home/team/vaibhav.png"
        />

        <!-- The name -->
        <div class="font-weight-bold text-h5 mt-6">
          Vaibhav Gupta
        </div>

        <!-- The designation -->
        <div>
          COO & Project Head
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
// Export the SFC
export default {
  // Name of the component
  name: "MeetTheTeam"
}
</script>

<style lang="stylus" scoped>
.section
  .box
    width 300px
    height 300px
    border-radius 4px
</style>
